<template>
  <div class="sidebar-detached sidebar-left">
    <div class="sidebar">
      <div class="sidebar-shop" :class="{ show: mqShallShowLeftSidebar }">
        <b-row>
          <b-col cols="12">
            <h6 class="filter-heading d-none d-lg-block">Filtrer par :</h6>
          </b-col>
        </b-row>

        <!-- Filters' Card -->
        <b-card>
          <!-- Categories -->
          <div class="product-categories">
            <h6 class="filter-title">Catégories</h6>
            <b-form-checkbox
                v-for="option in filterOptions.categories"
                class="mb-1"
                v-model="filters.categories"
                :key="option.slug"
                :value="option.slug"
            >
              {{ option.name }}
            </b-form-checkbox>
          </div>

          <!-- Brands -->
          <div class="brands">
            <h6 class="filter-title">Marques</h6>
            <b-form-checkbox
                v-for="option in filterOptions.brands"
                class="mb-1"
                v-model="filters.brands"
                :key="option.slug"
                :value="option.slug"
            >
              {{ option.name }}
            </b-form-checkbox>
          </div>
        </b-card>
      </div>
    </div>

    <div
      class="body-content-overlay"
      :class="{ show: mqShallShowLeftSidebar }"
      @click="$emit('update:mq-shall-show-left-sidebar', false)"
    />
  </div>
</template>

<script>
import {BRow, BCol, BCard, BFormCheckbox} from "bootstrap-vue";

export default {
  name: "StocksViewLeftFilterSidebar",
  components: {
    BFormCheckbox,
    BRow,
    BCol,
    BCard,
  },
  props: {
    filters: {
      type: Object,
      required: true,
    },
    filterOptions: {
      type: Object,
      required: true,
    },
    mqShallShowLeftSidebar: {
      type: Boolean,
      required: true,
    },
  },
};
</script>

<style lang="scss">
@import "~@core/scss/vue/libs/vue-slider.scss";
</style>

<style lang="scss" scoped>
.categories-radio-group,
.brands-radio-group {
  ::v-deep > .custom-control {
    margin-bottom: 0.75rem;
  }
}
</style>
